import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "8UbZ3LysdL",
				"width": 439.2152907596763,
				"height": 62.140625,
				"left": 536.6285559249734,
				"top": 250.17968749999997,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: left;\"><span style=\"font-size: 42.14px;font-family: 微软雅黑;\">${title}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "TFjvFJQGlS",
				"width": 170.79,
				"height": 172.05,
				"left": 375.015,
				"top": 206.69290947870272,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "none",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": `<p style=\"text-align: center;\"><span style=\"font-size: 133.27px;font-family: Impact;letter-spacing: 2.8979591836734695px;\">${serial}</span></p>`,
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "top"
				},
				"flipH": false,
				"flipV": false
			}
		],
		background
	}
}